import dayjs from 'dayjs'

export type ActivityTimeLabel =
  | { kind: 'today'; time: string }
  | { kind: 'yesterday'; time: string }
  | { kind: 'date'; text: string }

/** 今天 / 昨天按本地日历日切；更早只留月日。无法解析时返回 null。 */
export function activityTimeLabel(
  iso: string,
  now: Date = new Date(),
  language = 'zh-CN',
): ActivityTimeLabel | null {
  const time = dayjs(iso)
  if (!iso || !time.isValid()) return null

  const hm = time.format('HH:mm')
  const startToday = dayjs(now).startOf('day')
  const startTomorrow = startToday.add(1, 'day')
  if (!time.isBefore(startToday) && time.isBefore(startTomorrow)) {
    return { kind: 'today', time: hm }
  }

  const startYesterday = startToday.subtract(1, 'day')
  if (!time.isBefore(startYesterday) && time.isBefore(startToday)) {
    return { kind: 'yesterday', time: hm }
  }

  const text = language.toLowerCase().startsWith('zh')
    ? time.format('M月D日')
    : time.format('MMM D')
  return { kind: 'date', text }
}
